import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Radio from 'widgets/Radio/Radio';
import { SuggestedOrderFrequencyShape } from 'apps/ordersReserved/types';
import suggestedOrderFopFrequencies from '../../../utils/suggestedOrderFopFrequencies';
import { wa } from 'apps/analytics';
import { pageEvents, pageEventFields } from '../../../analytics';
import { gtm } from 'apps/gtm';

export default class SuggestedOrderFopControlsView extends PureComponent {
  static propTypes = {
    sku: PropTypes.string.isRequired,
    frequency: SuggestedOrderFrequencyShape,
    frequencyUpdatingSkus: PropTypes.array,
    updateFrequency: PropTypes.func.isRequired,
  };

  onChange = (event) => {
    wa.triggerPageEventWithDescription(pageEvents.SUGGESTED_ORDER_CHANGE_PRODUCT_FREQUENCY, {
      [pageEventFields.SKU]: this.props.sku,
      [pageEventFields.FREQUENCY]: event.target.value,
    });
    gtm.trigger('gtm:ordersReserved', { ordersReservedAction: `${event.target.value} click` });
    this.props.updateFrequency({ sku: this.props.sku, frequency: event.target.value });
  };

  render() {
    const { sku, frequency, frequencyUpdatingSkus } = this.props;
    const isUpdating = frequencyUpdatingSkus.includes(sku);
    return (
      <section className="orL-suggestedOrderFop__controls">
        {isUpdating && <div className="gn-spinner" />}
        {suggestedOrderFopFrequencies.map(freq => (
          <div key={freq.value} className="or-suggestedOrderFop__radioContainer">
            <Radio
              name={`frequency-${sku}`}
              value={freq.value}
              label={freq.label}
              checked={frequency === freq.value}
              onChange={this.onChange}
              small
            />
          </div>
        ))}
      </section>
    );
  }
}
